import { handleApiOrder } from './';
import { convertDateFromUTC } from './../../services/dst';
import { permissions } from './../../constants'
import Storage from './../../services/Storage'
import handlePermission from './../../containers/app/handlePermission'
import OrderHelper from './../../services/orderHelper';

// EditOrder
const EditOrder = (dataOrder, dataItems, state, orderRes) => {
    let save_item = false
    if(!handlePermission(permissions.OrderUpdateOrder)) {
        save_item = true
    }

    let informationFill = {
        key: 1,
        ID: dataOrder['ID'],
        channel: typeof dataOrder['ChannelName'] === 'string' ? dataOrder['ChannelName'].trim() : dataOrder['ChannelName'],
        channel_short_name: typeof dataOrder['ChannelShortName'] === 'string' ? dataOrder['ChannelShortName'].trim() : dataOrder['ChannelShortName'],
        channel_id: typeof dataOrder['ChannelID'] === 'string' ? dataOrder['ChannelID'].trim() : dataOrder['ChannelID'],
        channel_order: typeof dataOrder['ChannelOrderID'] === 'string' ? dataOrder['ChannelOrderID'].trim() : dataOrder['ChannelOrderID'],
        order_date: dataOrder['OrderDT'] ? convertDateFromUTC(dataOrder['OrderDT']) : null,
        ref: typeof dataOrder['ReferenceNumberCH'] === 'string' ? dataOrder['ReferenceNumberCH'].trim() : dataOrder['ReferenceNumberCH'],
        customer: '',
        channel_customer: dataOrder['ChannelCustomerID'] ? dataOrder['ChannelCustomerID'] : '',
        name: typeof dataOrder['ConsigneeNameCH'] === 'string' ? dataOrder['ConsigneeNameCH'].trim() : dataOrder['ConsigneeNameCH'],
        yomigana: typeof dataOrder['ConsigneeKanaNameCH'] === 'string' ? dataOrder['ConsigneeKanaNameCH'].trim() : dataOrder['ConsigneeKanaNameCH'],
        phone: typeof dataOrder['ConsigneePhoneCH'] === 'string' ? dataOrder['ConsigneePhoneCH'].trim() : dataOrder['ConsigneePhoneCH'],
        email: typeof dataOrder['ConsigneeEmailCH'] === 'string' ? dataOrder['ConsigneeEmailCH'].trim() : dataOrder['ConsigneeEmailCH'],
        country: typeof dataOrder['DestinationCountryCH'] === 'string' ? dataOrder['DestinationCountryCH'].trim() : dataOrder['DestinationCountryCH'],
        postal_code: typeof dataOrder['ConsigneePostalCodeCH'] === 'string' ? dataOrder['ConsigneePostalCodeCH'].trim() : dataOrder['ConsigneePostalCodeCH'],
        address1: typeof dataOrder['ConsigneeAddress1CH'] === 'string' ? dataOrder['ConsigneeAddress1CH'].trim() : dataOrder['ConsigneeAddress1CH'],
        address2: typeof dataOrder['ConsigneeAddress2CH'] === 'string' ? dataOrder['ConsigneeAddress2CH'].trim() : dataOrder['ConsigneeAddress2CH'],
        address3: typeof dataOrder['ConsigneeAddress3CH'] === 'string' ? dataOrder['ConsigneeAddress3CH'].trim() : dataOrder['ConsigneeAddress3CH'],
        address4: typeof dataOrder['ConsigneeAddress4CH'] === 'string' ? dataOrder['ConsigneeAddress4CH'].trim() : dataOrder['ConsigneeAddress4CH'],
        address_type: typeof dataOrder['AddressType'] === 'string' ? dataOrder['AddressType'].trim() : dataOrder['AddressType'],
        terms: typeof dataOrder['PaymentTermCH'] === 'string' ? dataOrder['PaymentTermCH'].trim() : dataOrder['PaymentTermCH'],
        preferred_time: typeof dataOrder['DeliveryTimeCH'] === 'string' ? dataOrder['DeliveryTimeCH'].trim() : dataOrder['DeliveryTimeCH'],
        currency: typeof dataOrder['CurrencyCH'] === 'string' ? dataOrder['CurrencyCH'].trim() : dataOrder['CurrencyCH'],
        status_id: typeof dataOrder['StatusID'] === 'string' ? dataOrder['StatusID'].trim() : dataOrder['StatusID'],
        last_time_update: dataOrder['LastUpdateDT'] ? convertDateFromUTC(dataOrder['LastUpdateDT']) : null,
        LastUpdateOrderDT: typeof dataOrder['LastUpdateDT'] === 'string' ? dataOrder['LastUpdateDT'].trim() : dataOrder['LastUpdateDT'],
        creator_update: typeof dataOrder['LogNameCH'] === 'string' ? dataOrder['LogNameCH'].trim() : dataOrder['LogNameCH'],
        order_parent_id: typeof dataOrder['OrderParentID'] === 'string' ? dataOrder['OrderParentID'].trim() : dataOrder['OrderParentID'],
        FulfillmentOption: typeof dataOrder['FulfillmentOption'] === 'string' ? dataOrder['FulfillmentOption'].trim() : dataOrder['FulfillmentOption'],
        CollectAmount: dataOrder['CollectAmount'],
        Remark: dataOrder['Remark'],
        HandlingCharge: dataOrder['HandlingCharge'],
        NoOfPackages: dataOrder['NoOfPackages'],
        save_item
    }

    let itemsFill = dataItems.map((item, key) => {
        return {
            key,
            id: item.ID,
            checked: false,
            no: undefined,
            item_code: typeof item['ItemCode'] === 'string' ? item['ItemCode'].trim() : item['ItemCode'],
            item_name: typeof item['ItemName'] === 'string' ? item['ItemName'].trim() : item['ItemName'],
            sku: typeof item['SKU'] === 'string' ? item['SKU'].trim() : item['SKU'],
            item_value: OrderHelper.item.priceUnit(item),
            price_adjusted: OrderHelper.item.priceAdjusted(item),
            price_adjustment: OrderHelper.item.priceAdjustment(item),
            is_discount: OrderHelper.item.priceIsDiscount(item),
            qty: typeof item['QuantityOrderedIN'] === 'string' ? item['QuantityOrderedIN'].trim() : item['QuantityOrderedIN'],
            total_value: typeof item['QuantityOrderedIN'] * OrderHelper.item.priceAdjusted(item),
            origin: typeof item['CountryOfOriginCH'] === 'string' ? item['CountryOfOriginCH'].trim() : item['CountryOfOriginCH'],
            channel_order_item: typeof item['OrderItemID'] === 'string' ? item['OrderItemID'].trim() : item['OrderItemID'],
            LastUpdateItemDT: typeof item['LastUpdateDT'] === 'string' ? item['LastUpdateDT'].trim() : item['LastUpdateDT'],
            save_item,
            addRow: false,
            cancelRow: true,
            HasApproveKeyWordBL: item['HasApproveKeyWordBL'],
            HasApproveKeyWordBLOrigin: item['HasApproveKeyWordBL'],
            ProhibitedKeyWord: item['ProhibitedKeyWord'],
            gst_paid: item['GSTPaid'],
            classes: {
                item_code: '',
                item_name: '',
                item_value: '',
                price_adjusted: '',
                price_adjustment: '',
                qty: '',
                total_value: '',
                origin: '',
                channel_origin_item: '',
                gst_paid: ''
            },
            orgData: {
                item_value: OrderHelper.item.priceUnit(item),
                price_adjusted: OrderHelper.item.priceAdjusted(item),
                price_adjustment: OrderHelper.item.priceAdjustment(item),
                is_discount: OrderHelper.item.priceIsDiscount(item),
            }
        }
    })

    let result = handleApiOrder(dataOrder, informationFill, itemsFill, state, orderRes)

    return {
        informationFill: result.informationFill,
        itemsFill: result.itemsFill,
        state: result.state
    }
}

export default EditOrder



// WEBPACK FOOTER //
// ./src/reducers/helper/helperEditOrder.js